// Fotos .DNG (Apple ProRAW e outras câmeras): o navegador não abre RAW, então tiramos a prévia JPEG
// que vem dentro do arquivo (TIFF/DNG). Assim não é preciso enviar arquivos de 30-100 MB ao servidor.
export const isDng = (f) => /\.dng$/i.test(f?.name || "") || /dng/i.test(f?.type || "");

const TYPE_SIZE = { 1: 1, 3: 2, 4: 4 };

const readIfd = (view, off, le) => {
  const n = view.getUint16(off, le);
  const tags = {};
  for (let i = 0; i < n; i += 1) {
    const e = off + 2 + i * 12;
    const tag = view.getUint16(e, le);
    const type = view.getUint16(e + 2, le);
    const count = view.getUint32(e + 4, le);
    const size = (TYPE_SIZE[type] || 4) * count;
    const at = size <= 4 ? e + 8 : view.getUint32(e + 8, le);
    const read = (j) => (type === 3 ? view.getUint16(at + j * 2, le) : type === 1 ? view.getUint8(at + j) : view.getUint32(at + j * 4, le));
    tags[tag] = Array.from({ length: Math.min(count, 64) }, (_, j) => read(j));
  }
  return { tags, next: view.getUint32(off + 2 + n * 12, le) };
};

// Retorna { blob: JPEG, orientation } da maior prévia JPEG do arquivo.
export const dngPreview = async (file) => {
  const buf = await file.arrayBuffer();
  const view = new DataView(buf);
  const le = view.getUint16(0) === 0x4949;
  if (view.getUint16(2, le) !== 42) throw new Error("Arquivo DNG inválido.");
  const ifds = [];
  const seen = new Set();
  const visit = (off) => {
    if (!off || off >= buf.byteLength || seen.has(off) || seen.size > 50) return;
    seen.add(off);
    const { tags, next } = readIfd(view, off, le);
    ifds.push(tags);
    (tags[330] || []).forEach(visit);
    visit(next);
  };
  visit(view.getUint32(4, le));
  const orientation = ifds[0]?.[274]?.[0] || 1;
  const jpegs = ifds.map((t) => {
    if (t[513] && t[514]) return [t[513][0], t[514][0]];
    if ((t[259]?.[0] === 7 || t[259]?.[0] === 6) && t[262]?.[0] === 6 && t[273]?.length === 1) return [t[273][0], t[279][0]];
    return null;
  }).filter(Boolean).filter(([o, n]) => n > 0 && o + n <= buf.byteLength && view.getUint16(o) === 0xffd8);
  if (!jpegs.length) throw new Error("Este DNG não tem prévia. Exporte a foto em JPG.");
  const [off, len] = jpegs.sort((a, b) => b[1] - a[1])[0];
  const bytes = new Uint8Array(buf, off, len);
  const hasExif = new TextDecoder("latin1").decode(bytes.subarray(0, Math.min(len, 65536))).includes("Exif");
  return { blob: new Blob([bytes], { type: "image/jpeg" }), orientation: hasExif ? 1 : orientation };
};
